import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import pedirSenhaAdmin from '../common/pedirSenhaAdmin';
import s from '../../pages/PedidosOrcamentos.module.css';

const UFS = ['AC','AL','AP','AM','BA','CE','DF','ES','GO','MA','MT','MS','MG','PA',
  'PB','PR','PE','PI','RJ','RN','RS','RO','RR','SC','SP','SE','TO'];

// Etapa 10 ("atenção especial", conforme o escopo original) — encerramento
// pede UF e município de onde a carga realmente terminou (pode ser
// diferente do UF/descarregamento planejado — rota muda na prática), por
// isso é um modalzinho à parte em vez do window.prompt usado no
// cancelamento (que só precisa de texto livre).
export default function ModalEncerrarMdfe({ mdfe, onClose, onEncerrado }) {
  const [uf, setUf] = useState(mdfe.uf_descarregamento || '');
  const [municipios, setMunicipios] = useState([]);
  const [municipio, setMunicipio] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState('');

  useEffect(() => {
    if (!uf) { setMunicipios([]); return; }
    api.get('/fiscal/mdfe/municipios', { params: { uf } })
      .then(r => setMunicipios(r.data || [])).catch(() => setMunicipios([]));
  }, [uf]);

  const confirmar = async () => {
    if (!uf || !municipio) { setErro('Informe UF e município de encerramento.'); return; }
    const [nome, codigo] = municipio.split('|');

    const senha = await pedirSenhaAdmin(
      `Encerrar o MDF-e ${mdfe.numero ? `nº ${mdfe.numero}` : ''} na SEFAZ, em ${nome}/${uf}. A operação é IRREVERSÍVEL.`,
      { acao: 'encerrar_mdfe', detalhes: `MDF-e chave ${mdfe.chave_acesso}` }
    );
    if (!senha) return;

    setEnviando(true); setErro('');
    try {
      const { data } = await api.post(`/fiscal/mdfe/${mdfe.id}/encerrar`, {
        uf_encerramento: uf, municipio_encerramento_codigo: codigo, municipio_encerramento_nome: nome,
        senha_admin: senha,
      });
      onEncerrado(data);
    } catch (err) {
      setErro(err.response?.data?.erro || 'Erro ao encerrar.');
    } finally { setEnviando(false); }
  };

  return (
    <div className={s.overlay} onMouseDown={e => e.target === e.currentTarget && onClose()}>
      <div className={s.modal} style={{ maxWidth: 420 }}>
        <div className={s.modalTitle}>🏁 Encerrar MDF-e {mdfe.numero ? `nº ${mdfe.numero}` : ''}</div>
        <div className={s.modalBody}>
          {erro && <div style={{ background: '#fee2e2', color: '#b91c1c', padding: 8, borderRadius: 4, marginBottom: 10, fontSize: 13 }}>{erro}</div>}
          <div style={{ display: 'flex', gap: 10 }}>
            <label style={{ fontSize: 12 }}>UF de encerramento *<br />
              <select className={s.inputErp} value={uf} onChange={e => { setUf(e.target.value); setMunicipio(''); }}>
                <option value="">—</option>
                {UFS.map(u => <option key={u} value={u}>{u}</option>)}
              </select>
            </label>
            <label style={{ fontSize: 12, flex: 1 }}>Município de encerramento *<br />
              <select className={s.inputErp} style={{ width: '100%' }} value={municipio}
                onChange={e => setMunicipio(e.target.value)} disabled={!uf}>
                <option value="">—</option>
                {municipios.map(m => <option key={m.codigo} value={`${m.nome}|${m.codigo}`}>{m.nome}</option>)}
              </select>
            </label>
          </div>
        </div>
        <div className={s.modalFooter}>
          <button className={s.btnErp} onClick={onClose}>Cancelar</button>
          <button className={s.btnErpPrimario} onClick={confirmar} disabled={enviando}>
            {enviando ? '...' : '✔ Confirmar Encerramento'}
          </button>
        </div>
      </div>
    </div>
  );
}
